import type { AxiosResponse } from 'axios'
import type { ICollectionResponseType, IListResponseType } from '@/types/api-types/IApiResponse'
import { CollectionResponse, ListResponse } from '@/models/response'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import ErrorType from '@/enum/ErrorType'

export default class ResponseTypeMapper {
  static CollectionResponseMapper<T>(
    collectionInAxiosResponse: AxiosResponse<ICollectionResponseType>
  ) {
    try {
      if (collectionInAxiosResponse?.data) {
        const collection = new CollectionResponse<T>(collectionInAxiosResponse.data)
        return collection.value
      }
      if (collectionInAxiosResponse !== undefined)
        throw new TypeError('Response type is not a collection')
      return collectionInAxiosResponse
    } catch (error: any) {
      return ErrorHandlerService.handleError(error, ErrorType.Network).catch((error) => error)
    }
  }

  static ListResponseMapper(listInAxiosResponse: AxiosResponse<IListResponseType>) {
    try {
      if (listInAxiosResponse?.data) return new ListResponse(listInAxiosResponse.data)
      if (listInAxiosResponse !== undefined) throw new TypeError('Reponse type in not a list')
      return listInAxiosResponse
    } catch (error: any) {
      return ErrorHandlerService.handleError(error, ErrorType.Network).catch((error) => error)
    }
  }
}
